import React              from 'react';
import { sortableHandle } from 'react-sortable-hoc';

function KirokusSortableHandle(props) {
    return <div style={{ cursor: 'move' }}  {...props}/>;
}
export default sortableHandle(KirokusSortableHandle);
